import { BaseCard } from '@bnnvara/cards';
import { CoverContent } from '@bnnvara/cards/src/components/GridCard/CoverContent/CoverContent';
import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/GridCard/GridCard';
import { formatDate } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';

export const ArticleCard = ({
  title,
  publishDate,
  thumbnail,
  commentCount,
  layout,
  ...props
}) => {
  const image = thumbnail.url || '/static/fallbackImages/videofallback.jpg';
  const pubDate = formatDate(publishDate);
  const backgroundImage = resizeImageSource(image, 500, 1);

  if (layout === null) {
    return (
      <BaseCard
        isLazyLoaded
        title={title}
        pubDate={pubDate}
        backgroundImage={backgroundImage}
        {...props}
        commentCount={commentCount}
      />
    );
  }
  return (
    <GridCard layout={layout}>
      <CoverContent
        title={title}
        pubDate={pubDate}
        backgroundImage={backgroundImage}
        commentCount={commentCount}
      />
    </GridCard>
  );
};

ArticleCard.defaultProps = {
  thumbnail: null,
  commentCount: 0,
  layout: null,
};

ArticleCard.propTypes = {
  thumbnail: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  commentCount: PropTypes.number,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default ArticleCard;
